var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"el-table__row"},[_c('td',{style:(_vm.leftWidth)},[_c('div',{staticClass:"cell"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.label)}})])]),_vm._v(" "),_c('td',{style:(_vm.rightWidth)},[_c('div',{staticClass:"cell"},[_vm._t("default",[_vm._v("\n        "+_vm._s(_vm.value)+"\n      ")])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ae275af","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/table/KeyValueTableRow.vue
// module id = null
// module chunks = 